export const INTERNAL_USER_TYPES = [
  'admin', 'claims_admin', 'billing_admin', 'director',
  'claims_manager', 'onboarding_manager', 'onboarding_specialist',
  'onboarding_support_specialist', 'referral', 'it_support',
];

export const USER_TYPE_TO_GROUP = {
  admin: 'internal',
  claims_admin: 'internal',
  billing_admin: 'internal',
  director: 'internal',
  claims_manager: 'internal',
  onboarding_manager: 'internal',
  onboarding_specialist: 'internal',
  onboarding_support_specialist: 'internal',
  referral: 'internal',
  it_support: 'internal',
  provider: 'provider',
  client: 'client',
  pending_client: 'client',
};

export function isInternalUser(userType) {
  return INTERNAL_USER_TYPES.includes(userType);
}

export function getIdentityRole(userType) {
  if (isInternalUser(userType)) return userType;
  if (userType === 'provider') return 'provider';
  if (userType === 'client' || userType === 'pending_client') return 'client';
  return null;
}
